exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addlist .el-dialog__body{padding:0}.validation .el-dialog__body{height:auto}.addlist .avatar-uploader.upimg{width:40px;height:40px}.addlist .upimg .el-upload-dragger{height:38px;width:38px}.addlist .upimg .el-upload-dragger img{height:40px}.addlist .avatar-uploader-icon{width:36px;height:36px;line-height:36px!important}.dapp .el-input,.newappname .el-input,.newauthor .el-input{width:100%;margin-right:20px}.adduserBottom .el-row .el-col{padding:10px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-481c2ad0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/packages/addlist/um-addlist.vue
// module id = 68
// module chunks = 0